import { useModuleBEM } from "@b2bportal/core-themes";
import type { ITripTerminus } from "@b2bportal/core-types";
import type { TripCategory } from "@overrides/types";
import clsx from "clsx";
import styles from "./FlightShopTitle.module.scss";
import { useFlightShopTitle } from "./hook";

interface FlightShopTitleProps {
  className?: string;
  destination?: ITripTerminus;
  tripCategory: TripCategory;
}

export const FlightShopTitle = ({
  className,
  tripCategory,
}: FlightShopTitleProps) => {
  const [block, cn] = useModuleBEM(styles, "FlightShopTitle");

  const { title, subtitle } = useFlightShopTitle(tripCategory);
  return (
    <div className={clsx(block, className)}>
      <h2 className={cn("title")}>{title}</h2>
      <div className={cn("subtitle")}>{subtitle}</div>
    </div>
  );
};
